import { validateDesignerScreen } from "../../designer-validation-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const validateTools: ToolHandlerGroup = {
  sync: {
    ui_validate_screen: (input) => validateDesignerScreen(getSdInstance(), input)
  }
};
